import { confirmedCancellationNoShow } from "../../utils/realTimeUtils"

/**
 * Gets all patients that are not assigned to a nurse
 * @param {*} todaySchedule
 * @returns {Patient[]} a list of these patients sorted by acuity high to low
 */
const getAddOnPatients = todaySchedule => {
	const addOnPatients = []

	for (const patient of todaySchedule.patientSchedule) {
		if (patient.internalStatus === "Completed") continue
		if (confirmedCancellationNoShow(patient)) continue
		if (patient.assignedNurse === null) {
			addOnPatients.push(patient)
		}
	}

	return addOnPatients.sort((a, b) => b.acuity - a.acuity)
}

export default getAddOnPatients
